// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qvKg","clinicsSelect":"styles_clinicsSelect__7y6cV"};